export const getters = {
  getFranchises($state) {
    return $state.sortOrder.map(id => $state.records[id]);
  },
  getAllFranchises($state) {
    return $state.allFranchises;
  },
  getFranchise: $state => id => {
    return $state.records[id] || {};
  },
  getCurrentFranchise($state) {
    return $state.currentFranchise;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getSelectedFranchiseIds($state) {
    return $state.selectedFranchiseIds;
  },
  getUnits($state) {
    return $state.units;
  },
  getAllUnits($state) {
    return $state.allUnits;
  },
  getAttendants($state) {
    return $state.attendants;
  },
  getUIFlagsUnits($state) {
    return $state.uiFlagsUnits;
  },
  getUIFlagsAttendants($state) {
    return $state.uiFlagsAttendants;
  },
};
